import metricTypes from './metric-types'
import products from './products'
import productCategories from './product-categories'
import suppliers from './suppliers'

export default {
    namespaced: true,
    modules: {
        metricTypes,
        products,
        productCategories,
        suppliers
    }
}
